import { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { BsStars } from "react-icons/bs";
import { IoMdArrowRoundBack, IoMdAddCircle } from "react-icons/io";
import { FaEdit, FaRocket, FaPaperPlane, FaQuestionCircle, FaCheck } from "react-icons/fa";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Switch, FormControlLabel, Collapse, TextField } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import AssessmentForm from "../../Mentor/AssessmentForm";
import "./ServiceCreateForm.css";

// ─────────────────────────────────────────────
// EDIT MODE
// ─────────────────────────────────────────────
function EditForm({
  state, updateState, updateFeature, createService, removedQuestionId,
  filteredAppointmentTypes, activeOptions, categories, packagePeriod,
  plainWeekDays, serviceIcons, dBody, dropFlowStyle, t, aiLimit, setShowAiAssistant,
}) {
  const descLen         = (state.description || "").length;
  const safePackageDays = Array.isArray(state.packageDays) ? state.packageDays : [];
  const safeTimeSlots   = Array.isArray(state.timeSlots)   ? state.timeSlots   : [];
  const safeFeatures    = Array.isArray(state.serviceFeatures) ? state.serviceFeatures : ["","","","",""];
  const safeAssessment  = Array.isArray(state.assessmentData)  ? state.assessmentData  : [];
  const activeTypeValue = state.activeType?.value ?? "";
  const isGroupPackage  = activeTypeValue === "group_package";
  const isPackageType   = ["one_to_one_package","group_package"].includes(activeTypeValue);
  const [useAi, setUseAi] = useState(false);

  const openAssessmentModal  = () => updateState("subMenu", "assessment");
  const closeAssessmentModal = () => updateState("subMenu", "");
  const handleAssessmentDone = () => {
    const ok = safeAssessment.every(item => {
      if (item.answerType === "select") { if (!item.answerIds||item.answerIds.length<2){toast.warn("Add at least two options.");return false;}return true; }
      if (!item.textTypeAnswer?.trim()){toast.warn("Add a valid answer.");return false;}return true;
    });
    if (ok) closeAssessmentModal();
  };
  const handleAiCheckbox = (e) => {
    const checked = e.target.checked; setUseAi(checked);
    if (checked) { if(!state.title||state.title.trim().length<3){toast.warn("Enter service name first (min 3 chars).");setUseAi(false);return;} setShowAiAssistant(true); }
    else setShowAiAssistant(false);
  };

  return (
    <>
      <div className="scf-root">
        <div className="scf-header">
          <button type="button" className="scf-back" onClick={()=>{updateState("menuType","");updateState("serviceId",null);}}><IoMdArrowRoundBack size={18}/></button>
          <div className="scf-header-text">
            <h2>{t("Edit Service")}</h2>
            <p>{t("Update your service details below")}</p>
          </div>
          <label className="scf-preq-toggle">
            <input type="checkbox" style={{display:"none"}} checked={!!state.assessmentNeed} onChange={e=>updateState("assessmentNeed",e.target.checked)}/>
            <span className="scf-toggle-track" style={{background:state.assessmentNeed?"#a00030":"#eef0f5"}}><span className="scf-toggle-thumb" style={{left:state.assessmentNeed?16:3}}/></span>
            {t("Need Pre Questions Form")}
          </label>
          {state.assessmentNeed&&<button type="button" className="scf-preq-btn" onClick={openAssessmentModal}>{safeAssessment.length>0?<><FaEdit size={13}/> {t("Update Pre Questions")}</>:<><IoMdAddCircle size={13}/> {t("Add Pre Questions")}</>}</button>}
        </div>

        <div className="scf-divider"/>

        <form onSubmit={e=>createService(e,state,true)} className="scf-form">
          <div className="scf-row-2">
            <div className="scf-field"><label className="scf-label">{t("Service Type")}</label><div className="scf-select"><Select classNamePrefix="react-select" menuPlacement="auto" options={filteredAppointmentTypes} value={state.activeType??null} onChange={e=>updateState("activeType",e)} menuPortalTarget={dBody} styles={dropFlowStyle} isDisabled={state.isEdit&&isGroupPackage}/></div></div>
            <div className="scf-field"><label className="scf-label">{t("Tell about your Service")}</label>
              <div className="scf-input-wrap">
                <input className="scf-input" type="text" placeholder={t("Mentoring")} value={state.title||""} required onChange={e=>updateState("title",e.target.value)}/>
                {aiLimit>0&&<label style={{display:"flex",alignItems:"center",gap:7,marginTop:8,cursor:"pointer",userSelect:"none",width:"fit-content"}}>
                  <input type="checkbox" checked={useAi} onChange={handleAiCheckbox} style={{accentColor:"#a00030",width:15,height:15,cursor:"pointer"}}/>
                  <span style={{display:"flex",alignItems:"center",gap:5,fontSize:12,fontWeight:600,color:useAi?"#a00030":"#6b7280"}}><BsStars size={13} color={useAi?"#a00030":"#9ca3af"}/> Use AI to fill description &amp; features</span>
                </label>}
              </div>
            </div>
          </div>
          <div className="scf-row-3">
            <div className="scf-field"><label className="scf-label">{t("Amount")} ₹</label><div className="scf-amount-wrap"><span className="scf-currency">₹</span><input className="scf-input scf-amount-input" type="number" placeholder="0" value={state.prize??""} onChange={e=>updateState("prize",e.target.value)}/></div></div>
            <div className="scf-field"><label className="scf-label">{t("Category")}</label><div className="scf-select"><Select classNamePrefix="react-select" menuPlacement="auto" options={categories} value={state.cat??null} onChange={e=>updateState("cat",e)} menuPortalTarget={dBody} styles={{menuPortal:b=>({...b,zIndex:9999}),container:b=>({...b,minWidth:"100%"})}}/></div></div>
            {!isPackageType&&<div className="scf-field"><label className="scf-label">{t("Duration")} (mins)</label><div className="scf-select"><Select classNamePrefix="react-select" menuPlacement="auto" options={activeOptions} value={state.activeMinutes??null} onChange={e=>updateState("activeMinutes",e)} menuPortalTarget={dBody} styles={dropFlowStyle}/></div></div>}
          </div>
          <div className="scf-field scf-field-full"><label className="scf-label">{t("Service Icon")}</label><div className="scf-icon-row">{serviceIcons.map((v,i)=><button key={i} type="button" className={`scf-icon-btn ${state.iconId===i?"selected":""}`} onClick={()=>updateState("iconId",i)}>{v.icon}</button>)}</div></div>
          {isGroupPackage&&<div className="scf-group-box">
            <div className="scf-group-box-header"><span className="scf-group-box-title">Group Package Settings</span></div>
            <div className="scf-field"><label className="scf-label">{t("Package Available Days")}</label><div className="scf-days-row">{plainWeekDays.map(d=>{const sel=safePackageDays.includes(d.value);return<button key={d.value} type="button" className={`scf-day-chip ${sel?"selected":""} ${state.isEdit?"scf-day-disabled":""}`} onClick={()=>{if(state.isEdit)return;const arr=[...safePackageDays];if(arr.includes(d.value))arr.splice(arr.indexOf(d.value),1);else arr.push(d.value);updateState("packageDays",arr);}}>{d.label.slice(0,3)}</button>;})}</div></div>
            <div className="scf-recurring-row"><span className="scf-recurring-label">{t("Recurring Meeting")}</span><FormControlLabel control={<Switch checked={!!state.isRecurring} onChange={(_,c)=>{if(!state.isEdit)updateState("isRecurring",c);}} color="primary"/>} label=""/></div>
            <Collapse in={!!state.isRecurring} timeout="auto" unmountOnExit>
              <div className="scf-row-3" style={{marginTop:"1rem"}}>
                <div className="scf-field"><label className="scf-label">{t("Package Period")}</label><div className="scf-select"><Select classNamePrefix="react-select" menuPlacement="auto" options={packagePeriod} value={packagePeriod.find(p=>p.value===state.packagePeriod)??null} onChange={s=>{if(!state.isEdit)updateState("packagePeriod",s.value);}} menuPortalTarget={dBody} styles={dropFlowStyle}/></div></div>
                <div className="scf-field"><label className="scf-label">{t("Duration")} (mins)</label><div className="scf-select"><Select classNamePrefix="react-select" menuPlacement="auto" options={activeOptions} value={state.activeMinutes??null} onChange={e=>{if(!state.isEdit){updateState("activeMinutes",e);updateState("timeSlots",[]);updateState("newStart","");}}} menuPortalTarget={dBody} styles={dropFlowStyle}/></div></div>
                <div className="scf-field"><label className="scf-label">{t("Number of People")}</label><input type="number" className="scf-input" value={state.groupSize??""} onChange={e=>{if(!state.isEdit)updateState("groupSize",e.target.value);}} placeholder="Enter number"/></div>
              </div>
              {state.activeMinutes&&<div className="scf-field" style={{marginTop:"1rem"}}><label className="scf-label">{t("Time Slot")}</label>
                {!state.isEdit?<input type="time" className="scf-input" style={{maxWidth:200}} value={state.newStart||""} onChange={e=>{const sv=e.target.value;updateState("newStart",sv);if(sv&&state.activeMinutes){const [h,m]=sv.split(":").map(Number);const sd=new Date(0,0,0,h,m),ed=new Date(sd.getTime()+state.activeMinutes.value*60000);const fmt=d=>d.toLocaleTimeString([],{hour:"numeric",minute:"2-digit",hour12:true});updateState("timeSlots",[{from:fmt(sd),to:fmt(ed)}]);}}}/>
                :safeTimeSlots.length>0&&<div className="scf-timeslot-display">{safeTimeSlots[0].from} → {safeTimeSlots[0].to}</div>}
              </div>}
            </Collapse>
          </div>}
          <div className="scf-desc-feat-row">
            <div className="scf-field" style={{flex:1}}>
              <label className="scf-label">{t("Short Description")} * <span className={descLen>270?"scf-char-warn":"scf-char-hint"}>({300-descLen} left)</span></label>
              <textarea className="scf-textarea" rows={8} placeholder={t("About your service ...")} maxLength={300} value={state.description||""} name="description" onChange={e=>updateState("description",e.target.value)} required/>
            </div>
            <div className="scf-field" style={{flex:1}}>
              <label className="scf-label">{t("Service Highlights")} * <span className="scf-char-hint">(5 required)</span></label>
              <div className="scf-features">
                {[
                  {ph:"Add focus areas (e.g., Business strategy)", max:100},
                  {ph:"(e.g., Growth roadmap)", max:100},
                  {ph:"(e.g., Design audit)", max:100},
                  {ph:"(e.g., Launch strategy)", max:100},
                  {ph:"(e.g., Campaign planning)", max:100},
                ].map((f,i)=>(
                  <div className="scf-feat-row" key={i}>
                    <span className="scf-feat-num">{i+1}</span>
                    <input className="scf-input serviceFeatInps" type="text" placeholder={f.ph}
                      value={safeFeatures[i]??""} onChange={e=>updateFeature(e.target.value,i)} maxLength={f.max}/>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {state.subMenu!=="assessment"&&state.assessmentNeed&&safeAssessment.length>0&&(
            <div className="scf-preq-preview">
              <div className="scf-preq-preview-header"><span>{t("PRE QUESTIONS FORM")}</span><span className="scf-preq-count">{safeAssessment.length} question{safeAssessment.length!==1?"s":""}</span></div>
              {safeAssessment.map((item,i)=>item.answerType==="select"?(
                <div key={i} className="mb-2"><label className="label-v2 mt-3 text-dark font-weight-bold">{i+1}. {item.question}</label><div className="d-flex flex-column align-items-start mb-2 mt-2 ml-4" style={{gap:"1rem"}}>{(item.answerIds||[]).map(d=><div key={d.answerId} className="d-flex" style={{gap:"1rem"}}><input type="radio" checked={false} value={d.answerId} readOnly/><p>{d.answer}</p></div>)}</div></div>
              ):(
                <div key={i} className="mb-2"><label className="label-v2 mt-3 text-dark font-weight-bold">{i+1}. {item.question}</label><div className="d-flex flex-column align-items-start ml-4"><TextField fullWidth margin="normal" variant="filled" placeholder={item.textTypeAnswer||item.answer||""} onChange={()=>{}}/></div></div>
              ))}
            </div>
          )}

          <div className="scf-submit-row">
            <button type="submit" className="scf-btn-submit">{t("Update")} {t("Your Service")} ✓</button>
          </div>
        </form>
      </div>

      {state.subMenu==="assessment"&&(
        <Modal show onHide={closeAssessmentModal}>
          <Modal.Header>{t("PRE QUESTION'S FORM")}<AiOutlineCloseCircle onClick={closeAssessmentModal} style={{cursor:"pointer",float:"right",marginBottom:8,width:20,height:20,color:"#000"}}/></Modal.Header>
          <Modal.Body className="d-flex flex-column" style={{overflowY:"auto"}}>
            <AssessmentForm editState={safeAssessment.length} assessmentListUpdated={safeAssessment} surveyQuestion={d=>updateState("assessmentData",d)} removedQuestionId={removedQuestionId}/>
            {safeAssessment.length>0&&<button onClick={handleAssessmentDone} disabled={!safeAssessment.length}>{state.menuType==="update-service"?t("Update Pre Questions"):t("Add My Service")}</button>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

// ─────────────────────────────────────────────
// CREATE MODE (Conversational UI)
// ─────────────────────────────────────────────
function CreateForm({
  state, updateState, updateFeature, createService, removedQuestionId,
  filteredAppointmentTypes, activeOptions, categories, packagePeriod,
  plainWeekDays, serviceIcons, dBody, dropFlowStyle, t,
  aiLimit, setShowAiAssistant, aiApplied,
}) {
  const isGroup    = state.activeType?.value === "group_package";
  const isPackage  = ["one_to_one_package","group_package"].includes(state.activeType?.value);

  const [messages, setMessages] = useState([]);
  const [phase, setPhase]       = useState("idle");
  const [typing, setTyping]     = useState(false);
  const [textVal, setTextVal]   = useState("");
  const [featIdx, setFeatIdx]   = useState(0);
  const [useAi, setUseAi]       = useState(false);

  const bottomRef = useRef(null);
  const inputRef  = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior:"smooth" }); }, [messages, typing]);

  useEffect(() => {
    botSay("👋 Hi! Let's create your new service. I'll guide you step by step.", () => ask("serviceType"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!aiApplied) return;
    setUseAi(false);
    botSay("✨ AI has filled in your description and features! Review and edit everything below, then launch.", () => setPhase("review"), 400);
  }, [aiApplied]);

  function addMsg(msg) { setMessages(prev => [...prev, { id: Date.now() + Math.random(), ...msg }]); }
  function botSay(text, cb, delay = 650) {
    setTyping(true);
    setTimeout(() => { setTyping(false); addMsg({ from:"bot", text }); cb && setTimeout(cb, 180); }, delay);
  }
  function userSay(text) { addMsg({ from:"user", text }); }

  function ask(nextPhase, delay = 450) {
    const Q = {
      serviceType: "What type of service are you offering?",
      serviceName: "What's the name of your service?",
      amount: "What's the price for this service? (₹)",
      category: "Which category does it fall under?",
      duration: "How long is each session?",
      icon: "Pick an icon that best represents your service.",
      groupDays: "Which days will this group package be available?",
      groupRecurring: "Will this be a recurring meeting?",
      groupDetails: "Fill in the group package details below.",
      description: "Write a short description for your service. (max 300 chars)",
      feature0: "Let's add 5 key features. What's Feature #1?",
      feature1: "Feature #2?", feature2: "Feature #3?", feature3: "Feature #4?", feature4: "Feature #5?",
      review: "Everything's set! Review your service and launch it. 🚀",
    };
    setTyping(true);
    setTimeout(() => { setTyping(false); addMsg({ from:"bot", text: Q[nextPhase]||"" }); setPhase(nextPhase); setTimeout(()=>inputRef.current?.focus(),100); }, delay);
  }

  const handleServiceType = (opt) => { updateState("activeType",opt); userSay(opt.label); botSay(`Got it — "${opt.label}" 👍`, () => ask("serviceName")); };
  const handleServiceName = () => { const v=textVal.trim(); if(!v||v.length<2){toast.warn("Please enter a valid name.");return;} updateState("title",v); userSay(v); setTextVal(""); botSay(`"${v}" — great name! 💡`, () => ask("amount")); };
  const handleAmount = () => {
    const v=textVal.trim();
    if(!v||isNaN(v)){toast.warn("Please enter a valid amount.");return;}
    updateState("prize",v);
    userSay(Number(v) === 0 ? "Free" : `₹${v}`);
    setTextVal("");
    botSay(`₹${v} noted.`, () => ask("category"));
  };
  const handleCategory = (opt) => { updateState("cat",opt); userSay(opt.label); botSay(`Category set to "${opt.label}" ✅`, () => { if(!isPackage) ask("duration"); else ask("icon"); }); };
  const handleDuration = (opt) => { updateState("activeMinutes",opt); userSay(`${opt.value} mins`); botSay(`${opt.value}-minute sessions. Got it!`, () => ask("icon")); };
  const handleIcon = (idx) => { updateState("iconId",idx); userSay(`Icon #${idx+1} selected`); botSay("Great icon choice! 🎨", () => { if(isGroup) ask("groupDays"); else ask("description"); }); };

  const toggleGroupDay = (d) => { const arr=[...(state.packageDays||[])]; if(arr.includes(d.value)) arr.splice(arr.indexOf(d.value),1); else arr.push(d.value); updateState("packageDays",arr); };
  const confirmGroupDays = () => { if(!state.packageDays?.length){toast.warn("Please select at least one day.");return;} userSay(state.packageDays.map(v=>v.charAt(0)+v.slice(1).toLowerCase()).join(", ")); botSay("Days saved! 📅", () => ask("groupRecurring")); };
  const handleGroupRecurring = (yes) => { updateState("isRecurring",yes); userSay(yes?"Yes, recurring":"No, one-time"); if(yes) botSay("Got it! Fill in the recurring details.", () => ask("groupDetails")); else botSay("One-time package noted.", () => ask("groupDetails")); };
  const confirmGroupDetails = () => {
    if(!state.activeMinutes){toast.warn("Please select a session duration.");return;}
    if(!state.groupSize||isNaN(state.groupSize)||Number(state.groupSize)<=0){toast.warn("Please enter a valid group size.");return;}
    if(!state.timeSlots?.length||!state.timeSlots[0]?.from){toast.warn("Please select a time slot.");return;}
    if(state.isRecurring&&(!state.packagePeriod||state.packagePeriod==="CUSTOM")){toast.warn("Please select a package period.");return;}
    const slotStr=`${state.timeSlots[0].from} → ${state.timeSlots[0].to}`;
    userSay(`${state.activeMinutes.value} mins · ${state.groupSize} people · ${slotStr}`);
    botSay("Group details saved! 🎉", () => ask("description"));
  };
  const handleDescription = () => {
    const v=textVal.trim();
    if(!v||v.length<10){toast.warn("Please enter at least 10 characters.");return;}
    updateState("description",v);
    userSay(v.length>80?v.slice(0,80)+"…":v);
    setTextVal("");
    botSay("Perfect! Now let's add 5 key features.", () => { setFeatIdx(0); ask("feature0"); });
  };
  const handleFeature = () => { const v=textVal.trim(); if(!v){toast.warn("Please enter a feature.");return;} updateFeature(v,featIdx); userSay(v); setTextVal(""); const next=featIdx+1; if(next<5){setFeatIdx(next); botSay(`Feature ${featIdx+1} ✅`, () => ask(`feature${next}`));} else {setFeatIdx(0); botSay("All 5 features added! 🎉 Let's review your service.", () => { setPhase("review"); ask("review"); });} };

  const closeAssessmentModal = () => updateState("subMenu","");
  const handleAssessmentDone = () => {
    const ok=(state.assessmentData||[]).every(item=>{
      if(item.answerType==="select"){if(!item.answerIds||item.answerIds.length<2){toast.warn("Add at least two options.");return false;}return true;}
      if(!item.textTypeAnswer?.trim()){toast.warn("Add a valid answer.");return false;}return true;
    });
    if(ok) closeAssessmentModal();
  };

  const handleTextSubmit = (e) => {
    e?.preventDefault();
    if(phase==="serviceName") handleServiceName();
    else if(phase==="amount") handleAmount();
    else if(phase==="description") handleDescription();
    else if(phase.startsWith("feature")) handleFeature();
  };

  const handleAiCheckbox = (e) => {
    const checked=e.target.checked; setUseAi(checked);
    if(checked){if(!state.title||state.title.trim().length<3){toast.warn("Enter service name first (min 3 chars).");setUseAi(false);return;} setShowAiAssistant&&setShowAiAssistant(true);}
    else setShowAiAssistant&&setShowAiAssistant(false);
  };

  // ── REVIEW PANEL ──
  const renderReview = () => (
    <div className="conv-review-card">
      {aiApplied&&<div className="conv-ai-applied-banner"><BsStars size={14} color="#a00030"/><span>AI-generated content applied — review and edit before launching</span></div>}

      <div className="conv-review-grid">
        <div className="conv-review-item"><span className="conv-review-key">Service Name</span><input className="conv-review-edit-input" value={state.title||""} onChange={e=>updateState("title",e.target.value)} placeholder="Service name"/></div>
        <div className="conv-review-item"><span className="conv-review-key">Price (₹)</span><div style={{position:"relative"}}><span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#15803d",fontWeight:700,fontSize:"0.95rem"}}>₹</span><input className="conv-review-edit-input" type="number" style={{paddingLeft:28}} value={state.prize||""} onChange={e=>updateState("prize",e.target.value)} placeholder="0"/></div></div>
        {state.activeType&&<div className="conv-review-item"><span className="conv-review-key">Type</span><span className="conv-review-val-badge">{state.activeType.label}</span></div>}
        <div className="conv-review-item"><span className="conv-review-key">Category</span>
          <Select classNamePrefix="conv-select" options={categories} value={state.cat??null} onChange={v=>updateState("cat",v)} menuPortalTarget={dBody}
            styles={{menuPortal:b=>({...b,zIndex:9999}),container:b=>({...b,width:"100%"}),control:b=>({...b,minHeight:44,fontSize:"0.95rem",border:"1.5px solid #e2e5ef",borderRadius:10,boxShadow:"none",background:"white"}),indicatorSeparator:()=>({display:"none"})}}/>
        </div>
        {!isGroup&&state.activeMinutes&&<div className="conv-review-item"><span className="conv-review-key">Duration</span>
          <Select classNamePrefix="conv-select" options={activeOptions} value={state.activeMinutes??null} onChange={v=>updateState("activeMinutes",v)} menuPortalTarget={dBody}
            styles={{menuPortal:b=>({...b,zIndex:9999}),container:b=>({...b,width:"100%"}),control:b=>({...b,minHeight:44,fontSize:"0.95rem",border:"1.5px solid #e2e5ef",borderRadius:10,boxShadow:"none",background:"white"}),indicatorSeparator:()=>({display:"none"})}}/>
        </div>}

        {isGroup&&<>
          <div className="conv-review-item conv-review-item--full">
            <span className="conv-review-key">Package Days <span style={{fontWeight:400,textTransform:"none",letterSpacing:0}}>(tap to change)</span></span>
            <div className="conv-review-days-row">
              {plainWeekDays.map(d=>{const sel=(state.packageDays||[]).includes(d.value);return(
                <button key={d.value} type="button" className={`conv-review-day-chip ${sel?"selected":""}`} onClick={()=>toggleGroupDay(d)}>
                  {sel&&<FaCheck size={9}/>}{d.label.slice(0,3)}
                </button>
              );})}
            </div>
          </div>
          <div className="conv-review-item"><span className="conv-review-key">Recurring</span>
            <div className="conv-review-toggle-row">
              <button type="button" className={`conv-review-toggle-btn ${state.isRecurring?"active":""}`} onClick={()=>updateState("isRecurring",true)}><FaCheck size={10}/> Yes</button>
              <button type="button" className={`conv-review-toggle-btn ${!state.isRecurring?"active":""}`} onClick={()=>{updateState("isRecurring",false);updateState("packagePeriod","CUSTOM");}}>No</button>
            </div>
          </div>
          {state.isRecurring&&<div className="conv-review-item"><span className="conv-review-key">Package Period</span>
            <Select classNamePrefix="conv-select" options={packagePeriod} value={packagePeriod.find(p=>p.value===state.packagePeriod)??null} onChange={v=>updateState("packagePeriod",v.value)} menuPortalTarget={dBody}
              styles={{menuPortal:b=>({...b,zIndex:9999}),container:b=>({...b,width:"100%"}),control:b=>({...b,minHeight:44,fontSize:"0.95rem",border:"1.5px solid #e2e5ef",borderRadius:10,boxShadow:"none",background:"white"}),indicatorSeparator:()=>({display:"none"})}}/>
          </div>}
          <div className="conv-review-item"><span className="conv-review-key">Duration (mins)</span>
            <Select classNamePrefix="conv-select" options={activeOptions} value={state.activeMinutes??null} onChange={v=>{updateState("activeMinutes",v);updateState("timeSlots",[]);updateState("newStart","");}} menuPortalTarget={dBody}
              styles={{menuPortal:b=>({...b,zIndex:9999}),container:b=>({...b,width:"100%"}),control:b=>({...b,minHeight:44,fontSize:"0.95rem",border:"1.5px solid #e2e5ef",borderRadius:10,boxShadow:"none",background:"white"}),indicatorSeparator:()=>({display:"none"})}}/>
          </div>
          <div className="conv-review-item"><span className="conv-review-key">Group Size</span><input className="conv-review-edit-input" type="number" value={state.groupSize||""} onChange={e=>updateState("groupSize",e.target.value)} placeholder="e.g. 10"/></div>
          <div className="conv-review-item conv-review-item--full"><span className="conv-review-key">Time Slot</span>
            <div style={{display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
              <input type="time" className="conv-review-edit-input" style={{maxWidth:180}} value={state.newStart||""}
                onChange={e=>{const sv=e.target.value;updateState("newStart",sv);if(sv&&state.activeMinutes){const [h,m]=sv.split(":").map(Number);const sd=new Date(0,0,0,h,m),ed=new Date(sd.getTime()+state.activeMinutes.value*60000);const fmt=d=>d.toLocaleTimeString([],{hour:"numeric",minute:"2-digit",hour12:true});updateState("timeSlots",[{from:fmt(sd),to:fmt(ed)}]);}}}/>
              {(state.timeSlots||[]).length>0&&state.timeSlots[0]?.from&&<span className="conv-review-timeslot-badge">{state.timeSlots[0].from} → {state.timeSlots[0].to}</span>}
            </div>
          </div>
        </>}

        <div className="conv-review-item conv-review-item--full"><span className="conv-review-key">Description</span>
          <div style={{position:"relative"}}>
            <textarea className="conv-review-edit-textarea" rows={4} maxLength={300} value={state.description||""} onChange={e=>updateState("description",e.target.value)} placeholder="Service description…"/>
            <span className={`conv-review-char-counter ${(state.description||"").length>270?"warn":""}`}>{300-(state.description||"").length} left</span>
          </div>
        </div>

        <div className="conv-review-item conv-review-item--full"><span className="conv-review-key">Features (5 required)</span>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {[0,1,2,3,4].map(i=>(
              <div key={i} className="conv-review-feat-row">
                <span className={`conv-review-feat-num ${(state.serviceFeatures||[])[i]?"filled":""}`}>{i+1}</span>
              <input className="conv-review-edit-input" value={(state.serviceFeatures||[])[i]||""}
      onChange={e=>updateFeature(e.target.value,i)} placeholder={`Feature ${i+1}…`} maxLength={100}/>
            </div>
            ))}
          </div>
        </div>
      </div>

      <div className={`conv-review-preq-card ${state.assessmentNeed&&(state.assessmentData||[]).length>0?"active":""}`}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <FaQuestionCircle size={16} color={state.assessmentNeed&&(state.assessmentData||[]).length>0?"#15803d":"#9ca3af"}/>
          <div>
            <p style={{margin:0,fontSize:"0.9rem",fontWeight:700,color:"#111827"}}>Pre-screening questions</p>
            <p style={{margin:0,fontSize:"0.78rem",color:"#6b7280"}}>{state.assessmentNeed&&(state.assessmentData||[]).length>0?`${state.assessmentData.length} question${state.assessmentData.length!==1?"s":""} added`:"Ask clients questions before they book (optional)"}</p>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          {state.assessmentNeed&&(state.assessmentData||[]).length>0?(
            <><button type="button" onClick={()=>updateState("subMenu","assessment")} className="conv-review-preq-edit-btn"><FaEdit size={11}/> Edit</button>
            <button type="button" onClick={()=>{updateState("assessmentNeed",false);updateState("assessmentData",[]);}} className="conv-review-preq-remove-btn">Remove</button></>
          ):(
            <button type="button" onClick={()=>{updateState("assessmentNeed",true);updateState("subMenu","assessment");}} className="conv-review-preq-add-btn"><IoMdAddCircle size={14}/> Add questions</button>
          )}
        </div>
      </div>

      <button type="button" className="conv-launch-btn" onClick={e=>createService(e,state,true)}>
        <FaRocket size={15}/> {t("Launch Service")}
      </button>
    </div>
  );

  // ── INPUT WIDGET ──
  const renderInput = () => {
    if (phase==="review"||phase==="idle") return null;

    if (phase==="serviceType") return (
      <div className="conv-widget">
        <div className="conv-option-grid">
          {filteredAppointmentTypes.map(opt=>(
            <button key={opt.value} type="button" className={`conv-option-card ${state.activeType?.value===opt.value?"selected":""}`} onClick={()=>handleServiceType(opt)}>
              {state.activeType?.value===opt.value&&<FaCheck size={11}/>}{opt.label}
            </button>
          ))}
        </div>
      </div>
    );

    if (phase==="category") return (
      <div className="conv-widget">
        <Select classNamePrefix="conv-select" options={categories} value={state.cat} onChange={handleCategory} menuPortalTarget={dBody} placeholder="Search category…" styles={{menuPortal:b=>({...b,zIndex:9999}),container:b=>({...b,width:"100%"})}}/>
      </div>
    );

    if (phase==="duration") return (
      <div className="conv-widget">
        <div className="conv-option-grid conv-option-grid--sm">
          {activeOptions.map(opt=>(
            <button key={opt.value} type="button" className={`conv-option-card conv-option-card--sm ${state.activeMinutes?.value===opt.value?"selected":""}`} onClick={()=>handleDuration(opt)}>
              {state.activeMinutes?.value===opt.value&&<FaCheck size={10} style={{color:"#a00030",marginBottom:3}}/>}
              <span className="conv-dur-num">{opt.value}</span><span className="conv-dur-unit">mins</span>
            </button>
          ))}
        </div>
      </div>
    );

    if (phase==="icon") return (
      <div className="conv-widget">
        <div className="conv-icon-grid">
          {serviceIcons.map((v,idx)=>(
            <button key={idx} type="button" className={`conv-icon-btn ${state.iconId===idx?"selected":""}`} onClick={()=>handleIcon(idx)}>
              {v.icon}
              {state.iconId===idx&&<span className="conv-icon-check"><FaCheck size={8}/></span>}
            </button>
          ))}
        </div>
      </div>
    );

    if (phase==="groupDays") return (
      <div className="conv-widget">
        <p className="conv-widget-hint">Tap days to select — tap again to deselect</p>
        <div className="conv-days-row">
          {plainWeekDays.map(d=>{const sel=(state.packageDays||[]).includes(d.value);return(
            <button key={d.value} type="button" className={`conv-day-chip ${sel?"selected":""}`} onClick={()=>toggleGroupDay(d)}>
              {sel&&<FaCheck size={10}/>}{d.label.slice(0,3)}
            </button>
          );})}
        </div>
        {(state.packageDays||[]).length>0&&<p className="conv-days-selected-label">Selected: {(state.packageDays||[]).map(v=>v.charAt(0)+v.slice(1).toLowerCase()).join(", ")}</p>}
        <button type="button" className="conv-confirm-btn" onClick={confirmGroupDays}>Confirm days →</button>
      </div>
    );

    if (phase==="groupRecurring") return (
      <div className="conv-widget">
        <div className="conv-option-grid conv-option-grid--sm">
          <button type="button" className={`conv-option-card conv-recurring-yes ${state.isRecurring===true?"selected":""}`} onClick={()=>handleGroupRecurring(true)}>
            {state.isRecurring===true&&<FaCheck size={11}/>} Yes, recurring
          </button>
          <button type="button" className={`conv-option-card conv-recurring-no ${state.isRecurring===false?"selected":""}`} onClick={()=>handleGroupRecurring(false)}>
            {state.isRecurring===false&&<FaCheck size={11}/>} No, one-time
          </button>
        </div>
      </div>
    );

    if (phase==="groupDetails") return (
      <div className="conv-widget conv-group-details-widget">
        <div className="conv-group-details-grid">
          {state.isRecurring&&<div className="conv-field"><label className="conv-label">Package Period</label>
            <Select classNamePrefix="conv-select" options={packagePeriod} value={packagePeriod.find(p=>p.value===state.packagePeriod)??null} onChange={s=>updateState("packagePeriod",s.value)} menuPortalTarget={dBody} styles={dropFlowStyle}/>
          </div>}
          <div className="conv-field"><label className="conv-label">Duration (mins)</label>
            <Select classNamePrefix="conv-select" options={activeOptions} value={state.activeMinutes} onChange={e=>{updateState("activeMinutes",e);updateState("timeSlots",[]);updateState("newStart","");}} menuPortalTarget={dBody} styles={dropFlowStyle}/>
          </div>
          <div className="conv-field"><label className="conv-label">No. of People</label>
            <input className="conv-input" type="number" value={state.groupSize||""} onChange={e=>updateState("groupSize",e.target.value)} placeholder="e.g. 10"/>
          </div>
        </div>
        {state.activeMinutes&&<div className="conv-field" style={{marginTop:"1rem"}}>
          <label className="conv-label">Session Time</label>
          <div style={{display:"flex",alignItems:"center",gap:14}}>
            <input type="time" className="conv-input conv-time-input" value={state.newStart||""}
              onChange={e=>{const sv=e.target.value;updateState("newStart",sv);if(sv&&state.activeMinutes){const [h,m]=sv.split(":").map(Number);const sd=new Date(0,0,0,h,m),ed=new Date(sd.getTime()+state.activeMinutes.value*60000);const fmt=d=>d.toLocaleTimeString([],{hour:"numeric",minute:"2-digit",hour12:true});updateState("timeSlots",[{from:fmt(sd),to:fmt(ed)}]);}}}/>
            {(state.timeSlots||[]).length>0&&state.timeSlots[0]?.from&&<span className="conv-timeslot-badge">{state.timeSlots[0].from} → {state.timeSlots[0].to}</span>}
          </div>
        </div>}
        <button type="button" className="conv-confirm-btn" style={{marginTop:"1rem"}} onClick={confirmGroupDetails}>Save &amp; continue →</button>
      </div>
    );

    if (phase==="description") return (
      <div className="conv-widget" style={{width:"100%"}}>
        {aiLimit>0&&state.title&&<label className="conv-ai-label">
          <input type="checkbox" checked={useAi} onChange={handleAiCheckbox} style={{accentColor:"#a00030",width:15,height:15,cursor:"pointer"}}/>
          <BsStars size={13} color={useAi?"#a00030":"#9ca3af"}/>
          <span style={{color:useAi?"#a00030":"#6b7280"}}>Use AI to fill description &amp; features automatically</span>
        </label>}
        <div style={{position:"relative"}}>
          <textarea className="conv-textarea" rows={5} maxLength={300} placeholder="Describe what clients will gain…" value={textVal} onChange={e=>setTextVal(e.target.value)} ref={inputRef}/>
          <span className={`conv-char-count ${textVal.length>270?"warn":""}`}>{300-textVal.length} left</span>
        </div>
        <button type="button" className="conv-confirm-btn" onClick={handleDescription}>Continue →</button>
      </div>
    );

    if (["serviceName","amount","feature0","feature1","feature2","feature3","feature4"].includes(phase)) {
      const isAmount = phase === "amount";
      const isFeat = phase.startsWith("feature");
      const featNum = isFeat ? parseInt(phase.replace("feature", "")) + 1 : null;

      return (
        <form className="conv-text-row" onSubmit={handleTextSubmit}>
          {isAmount && <span className="conv-rupee">₹</span>}
          <div className="conv-input-wrap">
            <input ref={inputRef} className="conv-text-input"
              type={isAmount ? "number" : "text"}
              placeholder={isAmount ? "Enter amount…" : isFeat ? `Feature ${featNum} of 5…` : "Type your answer…"}
              value={textVal} onChange={e=>setTextVal(e.target.value)}
              maxLength={isFeat ? 100 : undefined} autoFocus/>
            {isFeat && <span className="conv-char-count">{100 - textVal.length} left</span>}
          </div>
          <button className="conv-send-btn" type="submit"><FaPaperPlane size={14}/></button>
        </form>
      );
    }
    return null;
  };

  return (
    <>
      <div className="scf-root">
        {/* HEADER */}
        <div className="scf-header">
          <button type="button" className="scf-back" onClick={()=>{updateState("menuType","");updateState("serviceId",null);}}>
            <IoMdArrowRoundBack size={18}/>
          </button>
          <div className="scf-header-text">
            <h2>{t("New Service")}</h2>
            <p>{t("Answer the questions below to create your service")}</p>
          </div>
          {aiLimit>0&&state.title&&state.title.trim().length>=3&&phase!=="review"&&(
            <label className={`conv-ai-pill ${useAi?"active":""}`}>
              <input type="checkbox" checked={useAi} onChange={handleAiCheckbox} style={{accentColor:"#a00030",width:14,height:14,cursor:"pointer"}}/>
              <BsStars size={13} color={useAi?"#a00030":"#9ca3af"}/>
              <span>AI Assistant</span>
            </label>
          )}
        </div>

        <div className="scf-divider"/>

        {/* ── FULL-WIDTH CHAT THREAD ── */}
        <div className="conv-thread">
          {messages.map(msg => (
            <div key={msg.id} className={`conv-msg-row ${msg.from==="user"?"conv-msg-row--user":"conv-msg-row--bot"}`}>
              {msg.from==="bot" && <span className="conv-bot-avatar"><BsStars size={13}/></span>}
              <div className={`conv-bubble ${msg.from==="user"?"conv-bubble--user":"conv-bubble--bot"}`}>
                {msg.text}
              </div>
            </div>
          ))}

          {typing && (
            <div className="conv-msg-row conv-msg-row--bot">
              <span className="conv-bot-avatar"><BsStars size={13}/></span>
              <div className="conv-bubble conv-bubble--bot conv-typing">
                <span/><span/><span/>
              </div>
            </div>
          )}

          {phase==="review" && !typing && renderReview()}
          <div ref={bottomRef}/>
        </div>

        {/* INPUT DOCK */}
        {phase!=="review" && phase!=="idle" && (
          <div className="conv-dock">{renderInput()}</div>
        )}
      </div>

      {state.subMenu==="assessment" && (
        <Modal show onHide={closeAssessmentModal}>
          <Modal.Header>{t("PRE QUESTION'S FORM")}<AiOutlineCloseCircle onClick={closeAssessmentModal} style={{cursor:"pointer",float:"right",marginBottom:8,width:20,height:20,color:"#000"}}/></Modal.Header>
          <Modal.Body className="d-flex flex-column" style={{overflowY:"auto"}}>
            <AssessmentForm editState={(state.assessmentData||[]).length} assessmentListUpdated={state.assessmentData||[]} surveyQuestion={d=>updateState("assessmentData",d)} removedQuestionId={removedQuestionId}/>
            {(state.assessmentData||[]).length>0&&<button onClick={handleAssessmentDone} disabled={!(state.assessmentData||[]).length}>{t("Done")}</button>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default function ServiceCreateForm(props) {
  if (props.state.isEdit) return <EditForm {...props}/>;
  return <CreateForm {...props}/>;
}